import {useRef} from 'react'
import {AdDemandSource} from '../display-ad/types'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'

const adField = {
  adSpot: 'ad-spot',
  adDemandSource: 'ad-demand-source',
  adSizesRequested: 'ad-sizes-requested',
  adSize: 'ad-size',
  adStatus: 'ad-status',
}

const adEventKey = {
  adRequested: 'ad-requested',
  adViewed: 'ad-viewed',
  adLoaded: 'ad-loaded',
  adDelayed: 'ad-delayed',
  adFailed: 'ad-failed',
  adDismissed: 'ad-dismissed',
  adClosed: 'ad-closed',
}

const useAdEvents = (adDemand: AdDemandSource, adSpot: string, adSize: string) => {
  const adLoadTimer = useRef<NodeJS.Timeout | null>(null)
  const analyticsData = {
    [adField.adDemandSource]: adDemand,
    [adField.adSpot]: adSpot,
    [adField.adSizesRequested]: adSize,
  }

  function onRequested() {
    clearAdLoadTimer()
    startAdDelayedTimer()
    triggerAnalytics(adEventKey.adRequested, analyticsData).sendAll()
  }

  function onViewed() {
    triggerAnalytics(adEventKey.adViewed, analyticsData).sendAll()
  }

  function onFill() {
    clearAdLoadTimer()
    triggerAnalytics(adEventKey.adLoaded, analyticsData).sendAll()
  }

  function onFailed() {
    clearAdLoadTimer()
    triggerAnalytics(adEventKey.adFailed, analyticsData).sendAll()
  }

  function startAdDelayedTimer() {
    if (adLoadTimer.current) {
      console.warn('useAdEvents::Skipping triggerAdDelayedToLoadEvent()')
      return
    }

    adLoadTimer.current = setTimeout(() => {
      triggerAnalytics(adEventKey.adDelayed, analyticsData).sendAll()
    }, 5000)
  }

  function clearAdLoadTimer() {
    window.clearInterval(adLoadTimer.current as any)
    adLoadTimer.current = null
  }

  return {
    onRequested,
    onViewed,
    onFill,
    onFailed,
  }
}

export {useAdEvents, adEventKey, adField}
